const mobileLogos = document.querySelectorAll('.logo-mobile');

function changeLogo(addition) {
    let currentLogoIndex = 0;

    /* Needed do get current logo */
    for (let i = 0; i < mobileLogos.length; i++) {
        if (mobileLogos[i].classList.contains('active')) {
            currentLogoIndex = i;
            break;
        }
    }

    mobileLogos[currentLogoIndex].classList.remove("active");

    /* Needed to make the carousel */
    if ((currentLogoIndex + addition) < 0) {
        mobileLogos[mobileLogos.length - 1].classList.add('active');

        return;
    }
    if ((currentLogoIndex + addition) > (mobileLogos.length - 1)) {
        mobileLogos[0].classList.add('active');

        return;
    }

    mobileLogos[currentLogoIndex + addition].classList.add('active');
}

document.addEventListener('DOMContentLoaded', () => {
    /* First logo is always active */
    mobileLogos[0].classList.add('active');

    const leftArrow = document.getElementsByClassName('arrow-left')[0];
    const rightArrow = document.getElementsByClassName('arrow-right')[0];

    leftArrow.addEventListener('click', () => {
        changeLogo(-1);
    });
    rightArrow.addEventListener('click', () => {
        changeLogo(1);
    });
});